import React from 'react';
import { Lexicon, EditWrapper } from '@nitidbit/lexicon';
import { LEXICON_URL } from '../../constants';
import text from './VisitButtonStrings.json';
import './VisitButton.scss';

const VisitButton = ({ lexicon, clickHandler }) => (
  <button
    id="VisitButton"
    onClick={clickHandler}
    type="button"
  >
    <div className="visit-text">{lexicon.get('text')}</div>
    <div className="arrow-right wiggle" />
  </button>
);

const VisitButtonLexicon = new Lexicon(text, 'en', 'src/shared/VisitButton/VisitButtonStrings.json');

const EditableVisitButton = (props) => (
  <EditWrapper
    component={(editProps) => <VisitButton {...{...props, ...editProps}} />}
    lexicon={VisitButtonLexicon}
    apiUpdateUrl={LEXICON_URL}
  />
);

export default EditableVisitButton;
